var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "saleAnalysis" },
    [
      _c(
        "el-row",
        { attrs: { justify: "space-between", type: "flex" } },
        [
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "align-items": "center" },
              attrs: { lg: 14, md: 12, sm: 10, xl: 16, xs: 24 },
            },
            [
              _c("label", { staticStyle: { width: "70px" } }, [
                _vm._v(_vm._s(_vm.$t("sale-order::shopName"))),
              ]),
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: _vm.$t("system::common::select_placeholder"),
                    popperAppendToBody: false,
                  },
                  on: { change: _vm.handlerSelectChange },
                  model: {
                    value: _vm.selectedShop,
                    callback: function ($$v) {
                      _vm.selectedShop = $$v
                    },
                    expression: "selectedShop",
                  },
                },
                _vm._l(_vm.shopList, function (item) {
                  return _c("el-option", {
                    key: item.shopId,
                    attrs: { label: item.shopName, value: item.shopId },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "align-items": "center" },
              attrs: { lg: 10, md: 12, sm: 14, xl: 8, xs: 24 },
            },
            [
              _c("label", { staticStyle: { width: "150px" } }, [
                _vm._v(_vm._s(_vm.$t("sale-order::orderDate"))),
              ]),
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  clearable: false,
                  appendToBody: false,
                  "picker-options": _vm.pickerOptions,
                  "range-separator": _vm.$t("system::time::text::include"),
                  align: "right",
                  "end-placeholder": "结束日期",
                  "start-placeholder": "开始日期",
                  type: "daterange",
                  "unlink-panels": "",
                },
                on: { change: _vm.orderDateChange },
                model: {
                  value: _vm.orderDate,
                  callback: function ($$v) {
                    _vm.orderDate = $$v
                  },
                  expression: "orderDate",
                },
              }),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "8px" },
                  on: {
                    click: function ($event) {
                      _vm.$router.push({
                        path: _vm.reportJumpUrl().refundAnalysis,
                      })
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("system::common::btn::check_report")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "card-content", attrs: { gutter: 20 } },
        _vm._l(_vm.cardOptions, function (item, index) {
          return _c(
            "el-col",
            {
              key: index,
              staticClass: "card-item",
              attrs: { lg: 6, md: 6, sm: 12, xl: 6 },
            },
            [
              _c(
                "dataCard",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.cardLoading,
                      expression: "cardLoading",
                    },
                  ],
                  attrs: { active: 0, option: item },
                },
                [
                  _c("template", { slot: "total" }, [
                    _c("div", { staticClass: "card-content__total" }, [
                      _vm._v(_vm._s(item.suffix)),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 12, md: 12, sm: 24, xl: 12 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.reportCardLoading,
                    expression: "reportCardLoading",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.refundReasonConfigs },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 12, md: 12, sm: 24, xl: 12 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.reportCardLoading,
                    expression: "reportCardLoading",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.refundTimeConfigs },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24, sm: 24, xl: 24 } },
            [
              _c(
                "reportTable",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading",
                    },
                  ],
                  staticClass: "databoard-table",
                  attrs: { config: _vm.shopTableConfig },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_img"),
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("img", {
                              staticStyle: { width: "72px", height: "72px" },
                              attrs: { src: scope.row.productImage },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "spuId",
                      "min-width": "100",
                      prop: "spuId",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(_vm._s(_vm.$dataCheck(scope.row.spuId))),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_sales"),
                      "min-width": "100",
                      prop: "saleAmount",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(scope.row.saleAmount))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_refund"),
                      "min-width": "100",
                      prop: "refundAmount",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(scope.row.refundAmount))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_refundRate"),
                      "min-width": "100",
                      prop: "refundRate",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(scope.row.refundRate) + "%")
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_selfRefund"),
                      "min-width": "125",
                      prop: "initiativeRefundAmount",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(scope.row.initiativeRefundAmount)
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_selfRefundRate"),
                      "min-width": "150",
                      prop: "initiativeRefundAmountPercentage",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dataCheck(
                                    scope.row.initiativeRefundAmountPercentage
                                  ) + "%"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_protest"),
                      "min-width": "100",
                      prop: "refuseAmount",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(scope.row.refuseAmount))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_protestRate"),
                      "min-width": "125",
                      prop: "refuseAmountPercentage",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(
                                  scope.row.refuseAmountPercentage
                                ) + "%"
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24, sm: 24, xl: 24 } },
            [
              _c(
                "reportTable",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading",
                    },
                  ],
                  staticClass: "databoard-table",
                  attrs: { config: _vm.countryTableConfig },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_country"),
                      prop: "country",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(_vm._s(_vm.$dataCheck(scope.row.country))),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_sales"),
                      "min-width": "100",
                      prop: "saleAmount",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(scope.row.saleAmount))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_recieve"),
                      "min-width": "100",
                      prop: "recieveOkAmount",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(scope.row.recieveOkAmount))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_refund"),
                      "min-width": "100",
                      prop: "refundAmount",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(scope.row.refundAmount))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_refundRate"),
                      prop: "refundRate",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(scope.row.refundRate) + "%")
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_selfRefund"),
                      "min-width": "125",
                      prop: "initiativeRefundAmount",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(scope.row.initiativeRefundAmount)
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_selfRefundRate"),
                      "min-width": "150",
                      prop: "initiativeRefundAmountPercentage",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dataCheck(
                                    scope.row.initiativeRefundAmountPercentage
                                  ) + "%"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_protest"),
                      "min-width": "100",
                      prop: "refuseAmount",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(scope.row.refuseAmount))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("sale-order::refund::table_protestRate"),
                      "min-width": "125",
                      prop: "refuseAmountPercentage",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(
                                  scope.row.refuseAmountPercentage
                                ) + "%"
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticStyle: { "margin-top": "20px" },
          attrs: { justify: "space-between", type: "flex" },
        },
        [
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "align-items": "center" },
              attrs: { lg: 14, xl: 16 },
            },
            [
              _c("label", { staticStyle: { width: "70px" } }, [
                _vm._v(_vm._s(_vm.$t("sale-order::shopName"))),
              ]),
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: _vm.$t("system::common::select_placeholder"),
                  },
                  on: { change: _vm.refundSelectChange },
                  model: {
                    value: _vm.selectedShop,
                    callback: function ($$v) {
                      _vm.selectedShop = $$v
                    },
                    expression: "selectedShop",
                  },
                },
                _vm._l(_vm.shopList, function (item) {
                  return _c("el-option", {
                    key: item.shopId,
                    attrs: { label: item.shopName, value: item.shopId },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "align-items": "center" },
              attrs: { lg: 10, xl: 8 },
            },
            [
              _c("label", { staticStyle: { width: "150px" } }, [
                _vm._v(_vm._s(_vm.$t("sale-order::refundDate"))),
              ]),
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  clearable: false,
                  "picker-options": _vm.pickerOptions,
                  "range-separator": _vm.$t("system::time::text::include"),
                  align: "right",
                  "end-placeholder": "结束日期",
                  "start-placeholder": "开始日期",
                  type: "daterange",
                  "unlink-panels": "",
                },
                on: { change: _vm.refundDateChange },
                model: {
                  value: _vm.refundDate,
                  callback: function ($$v) {
                    _vm.refundDate = $$v
                  },
                  expression: "refundDate",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.reportCardLoading,
                    expression: "reportCardLoading",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.refundMoneyData },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24, sm: 24, xl: 12 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.reportCardLoading,
                    expression: "reportCardLoading",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.initiativeRefundData },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24, sm: 24, xl: 12 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.reportCardLoading,
                    expression: "reportCardLoading",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.refuseCountData },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }